module.exports = __webpack_public_path__ + "static/media/CalendarCheckActive.ce5fd485.svg";